
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import DecorationTrunk from "../../decorations/jungle/DecorationTrunk";
import TrapMarkerSpikes from "../../editor/trap-markers/jungle/TrapMarkerSpikes";
import PlatformMarkerFoliage3 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage3";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import SmashableMarkerVine from "../../editor/entity-markers/SmashableMarkerVine";
import PlatformMarkerFoliage4 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage4";
import PlatformFoliage1 from "../../platforms/jungle/PlatformFoliage1";
import PlatformFoliage2 from "../../platforms/jungle/PlatformFoliage2";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class JungleChunkEasy1 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 341, y ?? 108);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 4941, 661);
    this.add(editor_bounds_right);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, -331, 661);
    this.add(editor_bounds_left);

    // trunk_png_1
    const trunk_png_1 = new DecorationTrunk(scene, 1652, 694);
    this.add(trunk_png_1);

    // trunk_png_2
    const trunk_png_2 = new DecorationTrunk(scene, -137, 809);
    this.add(trunk_png_2);

    // trunk_png
    const trunk_png = new DecorationTrunk(scene, 455, 705);
    this.add(trunk_png);

    // trunk_png_3
    const trunk_png_3 = new DecorationTrunk(scene, 3986, 528);
    this.add(trunk_png_3);

    // trapSpikesMarker
    const trapSpikesMarker = new TrapMarkerSpikes(scene, 2603, -400);
    this.add(trapSpikesMarker);

    // platformMarkerFoliage
    const platformMarkerFoliage = new PlatformMarkerFoliage3(scene, -141, 503);
    this.add(platformMarkerFoliage);

    // platformMarkerFoliage_1
    const platformMarkerFoliage_1 = new PlatformMarkerFoliage3(scene, 1649, 386);
    this.add(platformMarkerFoliage_1);

    // platformMarkerFoliage_2
    const platformMarkerFoliage_2 = new PlatformMarkerFoliage3(scene, 2150, 591);
    this.add(platformMarkerFoliage_2);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 2400, -147);
    this.add(gemMarker_11);

    // megaGemMarker_2
    const megaGemMarker_2 = new MegaGemMarker(scene, 2688, -95);
    this.add(megaGemMarker_2);

    // smashableMarkerVine
    const smashableMarkerVine = new SmashableMarkerVine(scene, 2593, -213);
    this.add(smashableMarkerVine);

    // platformMarkerFoliage4
    const platformMarkerFoliage4 = new PlatformMarkerFoliage4(scene, 2508, -7);
    this.add(platformMarkerFoliage4);

    // platformFoliage1
    const platformFoliage1 = new PlatformFoliage1(scene, 2602, -355);
    this.add(platformFoliage1);

    // platformFoliage2
    const platformFoliage2 = new PlatformFoliage2(scene, 459, 402);
    this.add(platformFoliage2);

    // platformFoliage
    const platformFoliage = new PlatformFoliage1(scene, 2023, 151);
    this.add(platformFoliage);

    // trunk_png_4
    const trunk_png_4 = new DecorationTrunk(scene, 1012, 696);
    this.add(trunk_png_4);

    // trunk_png_5
    const trunk_png_5 = new DecorationTrunk(scene, 2138, 892);
    this.add(trunk_png_5);

    // platformFoliage_2
    const platformFoliage_2 = new PlatformFoliage1(scene, 2487, 440);
    this.add(platformFoliage_2);

    // trunk_png_6
    const trunk_png_6 = new DecorationTrunk(scene, 2491, 745);
    this.add(trunk_png_6);

    // trunk_png_7
    const trunk_png_7 = new DecorationTrunk(scene, 3131, 689);
    this.add(trunk_png_7);

    // platformFoliage_4
    const platformFoliage_4 = new PlatformFoliage1(scene, 1020, 390);
    this.add(platformFoliage_4);

    // platformMarkerFoliage_3
    const platformMarkerFoliage_3 = new PlatformMarkerFoliage4(scene, 3147, 375);
    this.add(platformMarkerFoliage_3);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 2027, 51);
    this.add(gemMarker);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 2142, 489);
    this.add(gemMarker_1);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 1628, 274);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 1021, 281);
    this.add(gemMarker_3);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 445, 274);
    this.add(gemMarker_4);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 2495, 320);
    this.add(gemMarker_5);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 3170, 228);
    this.add(gemMarker_6);

    // platformMarkerFoliage_4
    const platformMarkerFoliage_4 = new PlatformMarkerFoliage4(scene, 4007, 220);
    this.add(platformMarkerFoliage_4);

    // trapSpikesMarker_1
    const trapSpikesMarker_1 = new TrapMarkerSpikes(scene, 3992, 138);
    this.add(trapSpikesMarker_1);

    // megaGemMarker
    const megaGemMarker = new MegaGemMarker(scene, 4156, 127);
    this.add(megaGemMarker);

    // platformMarkerFoliage_5
    const platformMarkerFoliage_5 = new PlatformMarkerFoliage3(scene, 4462, 290);
    this.add(platformMarkerFoliage_5);

    // trunk_png_8
    const trunk_png_8 = new DecorationTrunk(scene, 4450, 595);
    this.add(trunk_png_8);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 4454, 188);
    this.add(gemMarker_7);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, -240, 465);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 2967, 304);
    this.add(checkpointMarker_1);

    // this (components)
    new ChunkBoundaries(this);
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
